import { SKIP_FORBIDDEN_RESPONSE_CONFIG } from 'constants/http';

const BASE = '/api/snapdocs/subscriptions';

export class SnapdocsSubscriptionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  getSubscriptions({ companyId }) {
    return this.#http.get(BASE, { ...SKIP_FORBIDDEN_RESPONSE_CONFIG, params: { companyId } });
  }

  registerSubscription({ companyId }) {
    return this.#http.post(BASE, null, {
      ...SKIP_FORBIDDEN_RESPONSE_CONFIG,
      params: { companyId },
    });
  }
}
